import { ReactNode } from 'react';
import { alpha, styled } from '@mui/material/styles';
import { CenterPositionedCol } from 'components/flex-containers';

// Bottom action bar (e.g. "Add shift"). Docks to the bottom edge with a safe-area-aware
// inset. Instead of a tinted frosted box (which read as a grey rectangle on the white page
// and left the button hugging the top), it fades the page's OWN background up from solid
// behind the button to transparent, so content scrolling underneath stays legible without
// any visible coloured surface. The fade region passes taps through to the content behind
// it; only the action button stays interactive.
const StyledContainer = styled(CenterPositionedCol)(({ theme }) => {
  const surface = theme.palette.background.default;
  return {
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    // Symmetric breathing room so the button reads as centred within the fade, plus a
    // safe-area inset and a thumb-zone lift at the very bottom.
    paddingTop: 28,
    paddingBottom: 'calc(env(safe-area-inset-bottom) + 36px)',
    background: `linear-gradient(to top, ${surface} 0%, ${surface} 72%, ${alpha(
      surface,
      0
    )} 100%)`,
    // Let the transparent fade zone click through; re-enable interaction on the button(s).
    pointerEvents: 'none',
    '& > *': {
      pointerEvents: 'auto'
    }
  };
});

export const FloatingBlurredLayout = ({
  children
}: {
  children: ReactNode;
}) => {
  return <StyledContainer>{children}</StyledContainer>;
};
